// extracted by mini-css-extract-plugin
export default {"modal":"kp","topline":"lp","img":"mp","textcontents":"np","heading":"op","copy":"pp","link":"qp","close":"rp","modalinner":"sp","container":"tp"};
    if(module.hot) {
      // 1714442366280
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  